export const heroMockup =
  'https://cdn.magicpatterns.com/uploads/byLFzspNeMyp1WNsYMx5mQ/ChatGPT_Image_2_sept_2026,_11_27_06_a.m.-Photoroom.png'

export const heroMicrocopy = [
  'Direkt digital nedladdning',
  'Utskriftsklara PDF:er',
  'Engångsbetalning',
]

export const stats = [
  { value: '10', unit: 'KOMPLETTA VOLYMER' },
  { value: '600', unit: 'SIDOR' },
  { value: '45', unit: 'LÄRANDEENHETER' },
  { value: '100%', unit: 'FÄRDIGT ATT UNDERVISA' },
]

export const transformationStats = [
  { value: '600', label: 'SIDOR LÄROPLAN' },
  { value: '6–16', label: 'ÅLDRAR SOM TÄCKS' },
  { value: '100%', label: 'REDO ATT ANVÄNDA' },
]

export const beforeItems = [
  'Lägga timmar på att planera varje idrottslektion eller träning',
  'Leta på internet efter övningar som inte passar nivån eller gruppen',
  'Ingen tydlig progression läsår efter läsår',
  'Osäker på hur man lär ut teknik och taktik på rätt sätt',
  'Inga färdiga utvärderingar, diplom eller facit',
]

export const afterItems = [
  'Ett helt läsår kartlagt för varje nivå — Grön, Blå och Röd',
  'Utskriftsklara lektioner, övningar och färdiga träningspass',
  'Tydlig progression från 6 till 16 år',
  'Enkel steg-för-steg-undervisning, även utan innebandybakgrund',
  'Inbyggda utvärderingar, facit, diplom och progressionskartor',
]

export const problems = [
  {
    icon: 'hourglass',
    text: 'Ingen tid kvar att planera meningsfulla innebandypass',
  },
  {
    icon: 'trending-down',
    text: 'Ser eleverna eller spelarna tappa intresset av samma gamla övningar',
  },
  {
    icon: 'users',
    text: 'Försöker undervisa blandade nivåer i samma grupp',
  },
  {
    icon: 'wallet',
    text: 'Ingen budget för dyrt specialmaterial',
  },
  {
    icon: 'help',
    text: 'Undervisar innebandy utanför din trygghetszon och känner dig osäker på varje moment',
  },
  {
    icon: 'layers',
    text: 'Hittar inget som fungerar för både små barn och tonåringar',
  },
]

export const includedItems = [
  {
    icon: 'library',
    title: '10 Kompletta Volymer',
    description: '3 nivåer: Grön, Blå, Röd',
  },
  {
    icon: 'file',
    title: '~600 sidor läroplan',
    description: 'Cirka 60 sidor per volym',
  },
  {
    icon: 'footprints',
    title: 'Steg-för-steg-övningar',
    description: 'Teknik, taktik, spel',
  },
  {
    icon: 'clipboard',
    title: 'Utvärderingar & Facit',
    description: 'Quiz, prov, projekt',
  },
  {
    icon: 'target',
    title: 'Praktiskt på varje sida',
    description: 'Direkt användbart i gympasalen eller på plan',
  },
  {
    icon: 'award',
    title: 'Diplom & progressionskarta',
    description: 'Håller motivationen uppe',
  },
]

export const instantAccessItems = [
  'De 10 kompletta volymerna, för åldrarna 6 till 16 år',
  'Teknik, taktik, övningar och utvärderingar i varje volym',
  'Enkla steg-för-steg-instruktioner för undervisning',
  'Färdiga prov, projekt och facit',
  'Utskriftsklart och digitalt — använd per lektion, termin eller läsår',
  'Du får aldrig slut på material',
]

export const bonuses = [
  {
    icon: 'presentation',
    number: 'BONUS 1',
    title: 'Innebandy Ready – Väggposter: Snabbguide till regler och positioner',
    description: 'Snabb uppslagsguide för väggen i gympasalen',
    value: 'VÄRDE 179 KR',
  },
  {
    icon: 'clipboard-list',
    number: 'BONUS 2',
    title: 'Innebandy Ready – Bedömningsmall: Kompetenskarta för spelarutveckling',
    description: 'Följ utvecklingen hos varje elev eller spelare',
    value: 'VÄRDE 249 KR',
  },
  {
    icon: 'flame',
    number: 'BONUS 3',
    title: 'Innebandy Ready – Uppvärmningskort: 10 färdiga rutiner',
    description: 'Redo att använda direkt — ingen extra planering',
    value: 'VÄRDE 349 KR',
  },
  {
    icon: 'mail',
    number: 'BONUS 4',
    title: 'Innebandy Ready – Föräldrabrev: Färdiga mallar för kommunikation hem',
    description: 'Färdiga brev till föräldrar och vårdnadshavare',
    value: 'VÄRDE 179 KR',
  },
  {
    icon: 'calendar',
    number: 'BONUS 5',
    title: 'Innebandy Ready – Terminsplanering: Färdig 12-veckorsmall',
    description: 'Få hela terminen strukturerad på ett ställe',
    value: 'VÄRDE 249 KR',
  },
]

export const pricingMicrocopy = [
  'Direkt digital tillgång',
  'Utskriftsklara PDF:er',
  'Engångsbetalning',
  'Livstidsåtkomst',
]

export const testimonials = [
  {
    quote:
      'Det jag vill ha är något jag kan öppna före lektionen och använda direkt — utan att behöva lägga kvällen på att leta efter och anpassa övningar.',
    attribution: 'Exempelprofil: Idrottslärare',
  },
  {
    quote:
      'En tydlig progression mellan åldrar och nivåer skulle göra enorm skillnad. Då vet jag inte bara vad vi ska göra idag, utan också vad nästa steg är.',
    attribution: 'Exempelprofil: Ungdomstränare',
  },
  {
    quote:
      'För mig är det viktigaste att materialet fungerar även när innebandy inte är mitt specialistområde. Tydliga instruktioner gör det mycket lättare att känna sig trygg i hallen.',
    attribution: 'Exempelprofil: Idrottslärare',
  },
  {
    quote:
      'Att ha övningar, utvärderingar och planering samlat på ett ställe är precis den typ av struktur som sparar tid under en full termin.',
    attribution: 'Exempelprofil: Idrottslärare',
  },
  {
    quote:
      'Jag vill kunna anpassa träningen efter gruppens nivå utan att börja om från noll. Ett system från Grön till Röd gör det betydligt enklare.',
    attribution: 'Exempelprofil: Klubbtränare',
  },
]

export const faqs = [
  {
    question: 'Hur får jag mitt material?',
    answer:
      'Direkt efter köpet får du digital tillgång till materialet. Alla volymer levereras som PDF-filer som du kan öppna digitalt eller skriva ut efter behov.',
  },
  {
    question: 'Fungerar det här om jag inte har någon innebandybakgrund?',
    answer:
      'Ja. Innebandy Ready är utformat med tydliga steg-för-steg-instruktioner så att även lärare och tränare utan tidigare innebandybakgrund kan följa materialet och genomföra lektioner och träningspass med en tydlig struktur.',
  },
  {
    question: 'Vilka åldrar och nivåer täcker det?',
    answer:
      'Materialet täcker cirka 6–16 år och är organiserat i tre progressiva nivåer: Grön för 6–9 år, Blå för 9–12 år och Röd för 12/13–16 år.',
  },
  {
    question: 'Är lektionerna anpassade efter Lgr22?',
    answer:
      '[BEHÅLL DENNA FAQ SOM PLACEHOLDER TILLS PÅSTÅENDET OM LGR22 HAR KONTROLLERATS OCH GODKÄNTS. HITTA INTE PÅ ETT SVAR.]',
    isPlaceholder: true,
  },
  {
    question: 'Vilket format är volymerna i?',
    answer:
      'Volymerna levereras digitalt i PDF-format och är utformade för att vara enkla att använda både på skärm och i utskriven form.',
  },
  {
    question: 'Kan jag skriva ut dem eller använda dem digitalt?',
    answer:
      'Ja. Materialet kan användas digitalt på dator eller surfplatta och skrivas ut när du vill ha fysiska arbetsblad, övningar eller annat material till lektionen eller träningen.',
  },
  {
    question: 'Finns det en återbetalningsgaranti?',
    answer:
      '[BEHÅLL DENNA FAQ SOM PLACEHOLDER TILLS DEN SLUTLIGA GARANTIPOLICYN HAR BEKRÄFTATS. HITTA INTE PÅ ETT SVAR.]',
    isPlaceholder: true,
  },
]

export const footerLinks = ['Villkor', 'Integritetspolicy', 'Kontakt']
